import { status } from 'skin/event/status';
import control from './control';
import forma from './form';

const appColor = (obj, form, story, data, d, action) => {
	console.log('[Цветовая гамма - форма] событие', obj);
	switch (obj.type) {
		case 'control':
			return control(obj, form, story, data, d, action);
		case 'form':
			return forma(obj, form, story, data, d, action);
		default:
	}
	return status.action;
};

export default appColor;
